import React, { useContext, useEffect } from "react";
import "./App.css";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import Navbar from "./components/layouts/Navbar";
import Home from "./components/layouts/Home";
import About from "./components/layouts/About";
import Blog from "./components/layouts/Blog";
import Contacts from "./components/layouts/Contacts";
import ConcertRecords from "./components/layouts/concertsRecords";

import NavContext from "./context/nav/navContext";
import { GET_CONTENT } from "./context/types";
const App = () => {
  const navContext = useContext(NavContext);

  const {
    visibleNav,
    visibleContent,
    getNavbar,
    getContent,
    removeContent
  } = navContext;
  useEffect(() => {
    if (window.innerWidth > 800) {
      getNavbar();
      getContent();
    } else {
      getContent();
    }
  }, []);
  const onClick = () => {
    if (window.innerWidth < 800) {
      removeContent();
      getNavbar();
    }
  };
  return (
    <Router>
      <div className="container">
        {!visibleNav && (
          <div className="navbar-btn">
            <button onClick={onClick}>
              {visibleNav ? (
                <i className="fas fa-chevron-right" />
              ) : (
                <i className="fas fa-chevron-left" />
              )}
            </button>
          </div>
        )}
        {visibleNav && <Navbar />}

        {visibleContent && (
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/about" component={About} />
            <Route exact path="/contacts" component={Contacts} />
            <Route exact path="/concerts" component={ConcertRecords} />
            <Route exact path="/blog" component={Blog} />
          </Switch>
        )}
      </div>
    </Router>
  );
};

export default App;
